import { get } from 'lodash/fp';

export default function convertCurrency(value, meta) {
  return value / (get('currency.divisor')(meta) || 1);
}
